import React from 'react';
import { VenueMarkerIcon } from './VenueMarkerIcon';

export const Legend: React.FC = () => {
    return <div className="legend hidden xl:block fixed z-10 bottom-12 right-12" style={{ width: 180 }}>
        <div className="border border-black text-black bg-lightoffwhite small-copy p-2 pb-3">
            <div className="font-bold mb-1 text-sm">Key</div>
                <div className="flex flex-row">
                    <VenueMarkerIcon color={'#F35EA1'} />
                    <div className="ml-2">
                        Cafe/Restaurant
                    </div>
                </div>
                <div className="flex flex-row">
                    <VenueMarkerIcon color={'#20B1B6'} />
                    <div className="ml-2">
                        Club
                    </div>
                </div>
                
                <div className="flex flex-row">
                    <VenueMarkerIcon color={'#FC4741'} />
                    <div className="ml-2">
                        Community space/hall
                    </div>
                </div>

                <div className="flex flex-row">
                    <VenueMarkerIcon color={'#4ebf8d'} />
                    <div className="ml-2">
                        Dedicated live music venue
                    </div>
                </div>
                <div className="flex flex-row">
                    <VenueMarkerIcon color={'#F3AF00'} />
                    <div className="ml-2">
                        Festival
                    </div>
                </div>
			    <div className="flex flex-row">
                    <VenueMarkerIcon color={'#719eff'} />
                    <div className="ml-2">
                        Pub/Hotel/Bar
                    </div>
                </div>
			    <div className="flex flex-row">
                    <VenueMarkerIcon color={'#ff8121'} />
                    <div className="ml-2">
                        Theatre or Performing art spaces
                </div>
            </div>
        </div>
    </div>
}